export enum SideDrawerType {
  FIND_EMPLOYEES = 'FIND_EMPLOYEES',
  DRAFTS = 'DRAFTS',
}

export interface UseContextFnTypeForPageSideDrawer {
  sideDrawerState: SideDrawerType | undefined;
  setSideDrawerState: (state: SideDrawerType | undefined) => void;
}

export const ALL_OPTIONS_VALUE = -1;
